<template lang="html">
  <v-layout row>
    <v-flex xs12>
      <v-card>
        <v-card-title primary-title class="grey lighten-4">
          <v-tooltip top>
                  <v-btn
                        slot="activator"
                        dark
                        @click.stop="dialog = true"
                        icon class="mx-0">
                     <v-icon color="red">help</v-icon>
                 </v-btn>
             <span>Tipo de Actuación Profesional</span>
          </v-tooltip>
          <h3 class="headline mb-0">Administración de Tipos de Actuación Profesional</h3>
          <v-spacer></v-spacer>
          <v-btn color="info" @click="nuevoTipoActuacion">NUEVOS MONTOS</v-btn>
        </v-card-title>
          <v-card-title primary-title class="grey lighten-4">
            <span>Servicio Electrónico BsS: {{ new Intl.NumberFormat("de-DE").format(servicio_electronico) }}</span>
            <v-spacer></v-spacer>
              <!-- <v-text-field
                  @change="onChange"
                  slot="input"
                  v-model="search"
                  append-icon="search"
                  label="Buscar"
                  single-line
                  hide-details
              ></v-text-field> -->
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-data-table
                :loading="loading"
                :headers="headers"
                :items="document_types"
                rows-per-page-text="Filas por Pág"
                :pagination.sync="pagination"
                :total-items="total"
                :rows-per-page-items="rowsPerPageItems"
                item-key="cdt_id"
                row
                wrap
                class="elevation-1"
             >
               <template slot="items" slot-scope="props">

                 <td>{{ props.item.clase_documento }}</td>
                 <td>{{ Number(parseFloat(props.item.pn).toFixedDown(2)).toLocaleString('es-VE') }} </td>
                 <td>{{ Number(parseFloat(props.item.pj).toFixedDown(2)).toLocaleString('es-VE') }} </td>
                 <td>{{ Number(parseFloat(props.item.gg_pn).toFixedDown(2)).toLocaleString('es-VE') }} </td>
                 <td>{{ Number(parseFloat(props.item.gg_pj).toFixedDown(2)).toLocaleString('es-VE') }} </td>

                 <td class="justify-center layout px-0">
                    <!-- <v-tooltip top>
                        <v-btn slot="activator" icon class="mx-0" >
                          <v-icon color="blue darken-2">description</v-icon>
                        </v-btn>
                        <span>Ver</span>
                    </v-tooltip> -->

                    <!-- <v-tooltip top>
                        <v-btn slot="activator" icon class="mx-0" @click="editItem(props.item)">
                          <v-icon color="green">edit</v-icon>
                        </v-btn>
                        <span>Editar Tipo de Documento</span>
                    </v-tooltip> -->

                   <!-- <v-tooltip top>
                        <v-btn slot="activator" icon class="mx-0">
                          <v-icon color="red">delete</v-icon>
                        </v-btn>
                        <span>Eliminar Tipo de Documento</span>
                    </v-tooltip> -->

                 </td>
               </template>
               <v-alert slot="no-results" :value="true" color="error" icon="warning">
                 La busqueda para  "{{ search }}" No resultó.
               </v-alert>
             </v-data-table>

          </v-card-text>
      </v-card>
    </v-flex>
    <!-- Inicio de dialogo -->
      <v-dialog v-model="dialogNuevosMontos" persistent width="600">
        <FormNuevosMontos v-on:closeDialog="closeDialog($event)"/>
      </v-dialog>
    <!-- Fin de dialogo -->
    <!-- Inicio de dialogo -->
      <!-- <v-dialog v-model="dialog" width="600">
        <FormDocumentType :loading="loading" :tipo="tipo" :datos="getDocumentType" v-on:closeDialogDT="closeDialogDT($event)" v-on:responseLoading="loading = $event" />
      </v-dialog> -->
    <!-- Fin de dialogo -->
    <v-dialog v-model="loading" hide-overlay persistent width="300">
        <v-card color="primary" dark>
            <v-card-text>
              Porfavor Espere...
              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from 'axios'
import FormDocumentType from '~/components/form/FormDocumentType.vue'
import FormNuevosMontos from '~/pages/cobranza/formNuevosMontos.vue'
import { mapGetters } from 'vuex'

Number.prototype.toFixedDown = function(digits) {
    var re = new RegExp("(\\d+\\.\\d{" + digits + "})(\\d)"),
        m = this.toString().match(re);
    return m ? parseFloat(m[1]) : this.valueOf();
};

export default {
    name: 'document-types-view',

    components: {
      FormDocumentType,
      FormNuevosMontos
    },

    computed: {
        ...mapGetters({
            authenticated: 'authCheck'
        }),
        pages () {
            return this.pagination.total
        },
        formTitle () {
            return this.editedIndex === -1 ? 'Nuevo Concepto' : 'Editar Concepto'
        },

        getDocumentType () {
            return this.editedItem
        }
    },

    mounted() {
        this.initComponent(1)
    },

    watch: {

        dialog (val) {
            val || this.close()
        },

        pagination() {
            this.initComponent();
        }

    },

    data () {
        return {
            servicio_electronico: 0,
            dialog: false,
            dialogNuevosMontos: false,
            document_types: [],
            activePagination: false,
            loading: false,
            total: 0,
            rowsPerPageItems: [20, 50, 100],
            search: '',
            tipo: '',
            pagination: {},
            editedIndex: -1,
            editedItem: {
              id: '',
              cdt_id: '',
              document_type_id: '',
              code: '',
              personality: '',
              name: '',
              amount: '',
              gg_amount: '',
              dt2_name: '',
              start_date: ''
            },
            defaultItem: {
              id: '',
              cdt_id: '',
              document_type_id: '',
              code: '',
              personality: '',
              name: '',
              amount: '',
              gg_amount: '',
              dt2_name: '',
              start_date: ''
            },
            headers: [
                { text: 'NOMBRE', value: 'clase_documento', sortable: false },
                { text: 'MONTO NATURAL', value: 'pn', sortable: false },
                { text: 'MONTO JURIDICA', value: 'pj', sortable: false },
                { text: 'GG NATURAL', value: 'gg_pn', sortable: false },
                { text: 'GG JURIDICA', value: 'gg_pj', sortable: false },
                // { text: 'MONTO (BsS)', value: 'amount', sortable: false },
                // { text: 'MONTO GG (BsS)', value: 'gg_amount', sortable: false },
                // { text: 'FECHA INICIO', value: 'start_date', sortable: false },
                // { text: 'ACCIONES', value: 'acciones', sortable: false }
            ],
        }
    },

    methods: {

        async initComponent () {
          this.loading = true;
          await axios.get(`/api/document_types/document-types?page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                  .then(res => {
                      this.document_types = res.data.document_types;
                      this.servicio_electronico = parseFloat(res.data.servicio_electronico.amount);
                      this.total = res.data.length;
                  })
                  .finally(() => this.loading = false);
                // if (this.search) {
                //     await axios.get(`/api/document_types/document-types-filter?query=${this.search}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                //         .then(res => {
                //             this.document_types = res.data.data;
                //             this.total = res.data.total;
                //         })
                //         .finally(() => this.loading = false);
                // }
                // if (this.pagination.sortBy && !this.search) {
                //     const direction = this.pagination.descending ? 'desc' : 'asc';
                //     await axios.get(`/api/document_types/document-types-order?direction=${direction}&sortBy=${this.pagination.sortBy}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                //         .then(res => {
                //             this.document_types = res.data.data;
                //             this.total = res.data.total;
                //         })
                //         .finally(() => this.loading = false);
                // }
                // if(!this.search && !this.pagination.sortBy) {
                //     await axios.get(`/api/document_types/document-types?page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                //         .then(res => {
                //             console.log(res)
                //             this.document_types = res.data.data;
                //             this.total = res.data.total;
                //         })
                //         .finally(() => this.loading = false);
                // }
        },

        nuevoTipoActuacion() {
          this.dialogNuevosMontos = true
        },

        searchFilterDocumentType () {
            this.initComponent(this.page,this.search)
        },

        onChange () {
          this.initComponent();
        },

        editItem (item) {
            this.tipo = "editar"
            this.editedIndex = this.document_types.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },

        close () {
            this.dialog = false
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                this.tipo = ''
            }, 300)
        },

        closeDialog (response) {
          if (response != null) {
              // var item = this.document_types.find(document_types => document_types.id === response.id)
              // if (this.tipo == 'crear') {
                  // this.document_types.push(response)
              // }else {
              //     Object.assign(item, response)
              // }
              this.initComponent();
          }
          this.dialogNuevosMontos = false
        },

        closeDialogDT (response) {
          if (response != null) {
              var item = this.document_types.find(document_types => document_types.id === response.id)
              // if (this.tipo == 'crear') {
                  this.document_types.push(response)
              // }else {
              //     Object.assign(item, response)
              // }
              this.initComponent();
          }
          this.dialog = false
          setTimeout(function(){
              this.editItem = {}
              this.tipo = ''
          }, 3000)
        }

    }

}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/cobranza/documentType.vue